import React from 'react';
import PropTypes from 'prop-types';
import Toggle from '../atoms/Toggle';
import Label from '../foundations/Label';
import css from './TableCellToggle.css';
import withTranslate from '../../containers/widgets/withTranslate';

const TableCellToggle = ({
    id,
    toggled,
    firstLabelKey = 'STATIC.BUTTONS.TOGGLE.NO',
    secondLabelKey = 'STATIC.BUTTONS.TOGGLE.YES',
    disabled,
    disableLabel,
    tdStyle,
    tdClassName = '',
    onToggle = () => {},
    labelEnterTransitionDelay = 700,
    labelExitTransitionDelay = 50,
    translate = () => {},
}) => {
    const getInnerRendered = () => {
        if (disabled && disableLabel) {
            return <Label className={css.disableLabel} text={disableLabel} />;
        } else {
            return [
                firstLabelKey && (
                    <span
                        style={{
                            opacity: toggled ? 0 : 1,
                            transition: `opacity ${toggled ? labelExitTransitionDelay : labelEnterTransitionDelay}ms`,
                        }}
                    >
                        {translate(firstLabelKey)}
                    </span>
                ),
                <Toggle
                    onToggle={e => onToggle(e.target.checked, id)}
                    style={{ display: 'inline-block', verticalAlign: 'middle', padding: '0 0 0 7px' }}
                    iconStyle={{ paddingLeft: 0 }}
                    checked={toggled}
                    disabled={disabled}
                />,
                secondLabelKey && (
                    <span
                        style={{
                            opacity: toggled ? 1 : 0,
                            transition: `opacity ${toggled ? labelEnterTransitionDelay : labelExitTransitionDelay}ms`,
                        }}
                    >
                        {translate(secondLabelKey)}
                    </span>
                ),
            ];
        }
    };

    return (
        <td style={{ textAlign: 'center', ...tdStyle }} className={tdClassName}>
            {getInnerRendered()}
        </td>
    );
};

TableCellToggle.propTypes = {
    id: PropTypes.string.isRequired,
    firstLabelKey: PropTypes.string,
    secondLabelKey: PropTypes.string,
    toggled: PropTypes.bool,
    disabled: PropTypes.bool,
    tdStyle: PropTypes.string,
    tdClassName: PropTypes.string,
    onToggle: PropTypes.func,
    labelEnterTransitionDelay: PropTypes.number,
    labelExitTransitionDelay: PropTypes.number,
    disableLabel: PropTypes.string,
    translate: PropTypes.func,
};

export default withTranslate(TableCellToggle);
